module.exports = __webpack_public_path__ + "static/media/logo-light.2dfec859.png";